export enum EBannerVerticalAlignment {
  Oben = 'top',
  Mitte = 'center',
  Unten = 'bottom',
}

export enum EBannerHorizontalAlignment {
  Links = 'left',
  Mitte = 'center',
  Rechts = 'right',
}
